<template>
    <div class="change">
        <template v-if="showContent">
            <div class="kv">
                <img src="/static/banner.jpg" />
            </div>
            <div class="change_box">
                <div class="change_top">
                    <div class="change_img">
                        <img src="/static/change.png" />
                    </div>
                    <div class="change_title">{{content}}</div>
                </div>
                <div class="change_cell">
                    <van-cell-group :border="false"
                        :style="{'padding-bottom':'20px','border-bottom':content=='医院转诊'?'1px solid rgba(162, 209, 249, 100)':'none'}"
                        class="cellGroup">
                        <van-field :label="title" v-model="address" readonly input-align="right" autosize rows="1"
                            type="textarea" />
                        <van-cell title=" 转诊至" :value="Newhospital" class="inputone" is-link arrow-direction="down"
                            @click="show = true" />
                    </van-cell-group>
                    <div class="imgList" v-if="content=='医院转诊'">
                        <div class="title">转院申请单</div>
                        <image-uploader ref="imgUploader" :title="''" :value="images" :num="num"
                            :history="checkItem.attach" @deleteCI="deleteCI"></image-uploader>
                    </div>
                </div>
            </div>
            <div class="btn">
                <van-button class="up" @click="next" :disabled="disabled">提交</van-button>
            </div>
            <van-popup v-model="show" round position="bottom" :style="{ height: '300px' }">
                <form action="/">
                    <van-search v-model="value" placeholder="请输入搜索关键词" @input="onSearch" />
                    <van-picker show-toolbar :columns="List" value-key="name" :style="{height:'246px'}"
                        @cancel="show = false" @confirm="confirm" />
                </form>

            </van-popup>
        </template>
        <template v-else>
            <div class="msg">

                <div class="msg-png">
                    <img :src="msgImg" alt="">
                </div>
                <div class="msg-bd">
                    <div class="title">{{msg.title}}</div>
                    <div class="desc" :style="{color:status ==2?'red':''}">{{msg.content}}</div>
                </div>
                <div class="btn">
                    <van-button class="back" @click="replace" v-if="status ==2">
                        {{ this.type=='drugstore'?'请重新提交转诊申请':'请重新上传审核材料'}}</van-button>
                    <van-button class="up" @click="back" v-if="status ==0">返回首页</van-button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import ImageUploader from "@/components/ImageUploader";
    import msg_upload from '@/assets/msg_upload.png';
    import msg_error from '@/assets/msg_error.png';
    import {
        mapGetters
    } from 'vuex'
    import {
        ApplyQuery,
        GetPatient,
        GetDrugstore,
        GetHospital,
        AttachDel,
        ReferralApply
    } from "@/api/api";
    import Vue from 'vue';
    import {
        Toast,
        Dialog
    } from 'vant';

    Vue.use(Toast);
    Vue.use(Dialog);
    export default {
        name: "change",
        components: {
            ImageUploader
        },
        computed: {
            ...mapGetters(['getPapid'])
        },
        data() {
            return {
                Newhospital: '',
                images: [],
                num: 9,
                show: false,
                content: '',
                address: '',
                title: '',
                List: [],
                type: '',
                value: '',
                status: '',
                checkItem: {
                    attach: [],
                },
                apply_hospital_id: 0,
                apply_doctor_id: 0,
                apply_drugstore_id: 0,
                showContent: false,
                disabled: false,
                msgImg: '',
                msg: {
                    title: '',
                    content: ''
                }
            }
        },
        created() {
            this.type = this.$route.query.value
            this.init()
            this.content = this.type == 'drugstore' ? '药房转诊' : '医院转诊'
            this.title = this.type == 'drugstore' ? '当前药房:' : '当前医院:'
        },
        methods: {
            async init() {
                let {
                    data
                } = await ApplyQuery({
                    papid: this.getPapid,
                    type: this.type
                })
                if (!data || data.length == 0) {
                    this.showContent = true
                } else {
                    this.showContent = false
                }
                this.status = data.status
                if (data.status == 0) {
                    this.msgImg = msg_upload
                    this.msg = {
                        title: '您的转诊申请已提交成功',
                        content: '请耐心等待项目办工作人员审核，审核工作将在5个工作日内完成。'
                    }
                } else if (data.status == 2) {
                    this.checkItem.attach = data.attach
                    for (let i in this.checkItem.attach) {
                        this.checkItem.attach[i].is_check = 0
                    }
                    // console.log(this.checkItem.attach, 'this.checkItem.attach')
                    this.msgImg = msg_error
                    this.msg = {
                        title: '转诊未通过',
                        content: data.remark
                    }
                } else {
                    this.showContent = true
                }
                let res = await GetPatient({
                    papid: this.getPapid,
                })
                this.address = this.type == 'drugstore' ? res.data.drugstore.name : res.data.hospital
                    .name
                if (this.type == 'drugstore') {
                    let {
                        data
                    } = await GetDrugstore()
                    this.List = data
                } else {
                    let {
                        data
                    } = await GetHospital()
                    this.List = data
                }

            },
            replace() {
                this.showContent = true
            },
            add() {
                this.$router.replace({
                    name: "ReApply"
                })
            },
            back() {
                this.$wechat.closeWindow()
            },
            async next() {
                if (this.type == 'drugstore') {
                    if (!this.Newhospital) {
                        Toast('请选择需要转诊的药房')
                    } else {
                        try {
                            this.disabled = true
                            let res = await ReferralApply({
                                papid: this.getPapid,
                                apply_drugstore_id: this.apply_drugstore_id
                            })
                            this.disabled = false
                            this.$router.replace({
                                name: "ReApply"
                            })
                            // console.log(res, 'res')
                        } catch (err) {
                            this.disabled = false
                            console.log(err)
                            Toast(err.response.data.message)
                        }
                    }
                } else {
                    if (!this.Newhospital) {
                        Toast('请选择需要转诊的医院')
                    } else if (this.images.length < 1) {
                        Toast('请上传照片')
                    } else {
                        try {
                            this.disabled = true
                            let images = []
                            for (let i in this.images) {
                                images.push(this.images[i].src)
                            }
                            let res = ReferralApply({
                                papid: this.getPapid,
                                apply_hospital_id: this.apply_hospital_id,
                                images: images
                            })
                            this.disabled = false
                            this.$router.replace({
                                name: "ReApply"
                            })
                            // console.log(res, 'res')
                        } catch (err) {
                            this.disabled = false
                            console.log(err)
                            Toast(err.response.data.message)
                        }
                    }
                }

            },
            async onSearch(value) {
                if (this.type == 'drugstore') {
                    let {
                        data
                    } = await GetDrugstore({
                        name: value
                    })
                    this.List = data
                } else {
                    let {
                        data
                    } = await GetHospital({
                        name: value
                    })
                    this.List = data
                }
            },
            deleteCI(val) {
                Dialog.confirm({
                        message: '确定删除？',
                    })
                    .then(() => {
                        AttachDel({
                            papid: this.getPapid,
                            id: val
                        }).then((res) => {
                            this.$forceUpdate();
                        }).catch((err) => {
                            Toast(err.response.data.message)
                        })
                    })
                    .catch((err) => {
                        // console.log(err);
                    });
            },
            confirm(value) {
                this.show = false
                this.Newhospital = value.name
                if (this.$route.query.value == 'drugstore') {
                    this.apply_drugstore_id = value.id
                } else {
                    this.apply_hospital_id = value.id
                }

            }
        }
    }
</script>
<style lang="scss" scoped>
    .van-cell__value {
        span {
            color: #323233;
        }
    }

    .change {
        height: 100%;
        width: 100%;

        .kv {
            height: 178px;
            width: 100%;
            margin-bottom: 20px;

            img {
                height: 100%;
                width: 100%;
            }
        }

        .change_box {
            margin: 0 25px;
            width: auto;
            min-height: 190px;
            border-radius: 10px;
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
            border: 1px solid rgba(255, 255, 255, 100);
            background: white;
            overflow: hidden;
            display: flex;
            flex-direction: column;

            .change_top {
                background: #4FAFFF;
                height: 40px;
                width: 100%;
                color: rgba(247, 248, 247, 100);
                font-size: 14px;
                display: flex;
                justify-content: flex-start;
                padding-left: 15px;
                box-sizing: border-box;
                align-items: center;

                .change_img {
                    height: 24px;
                    width: 24px;
                    margin-right: 11px;

                    img {
                        height: 24px;
                        width: 24px;
                    }
                }


            }

            .cellGroup {
                box-sizing: border-box;
            }

            .change_cell {
                flex: 1;
                width: 100%;
                padding: 20px 20px 0 20px;
                box-sizing: border-box;

                .btn {
                    margin: 0;
                    border-radius: 6px;
                }

            }

            .van-cell::after {
                display: none;
            }

            .btn:first-child {
                margin-bottom: 20px;
            }

        }

    }

    .imgList {
        padding-top: 20px;
        box-sizing: border-box;

        .title {
            font-size: 14px;
            padding-left: 15px;

        }
    }

    .msg {
        height: 100%;
        width: 100%;
        padding-top: 40px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-direction: column;

        .msg-png {
            width: 264px;
            height: 183px;
            margin-bottom: 30px;

            img {
                height: 100%;
                width: 100%;
            }
        }

        .msg-bd {
            width: 100%;
            padding: 0 70px;
            box-sizing: border-box;
            text-align: center;
            margin-bottom: 20px;

            .title {
                color: rgba(16, 16, 16, 100);
                font-size: 18px;
                font-family: PingFangSC-bold;
                margin-bottom: 15px;
            }

            .desc {
                color: rgba(160, 162, 162, 100);
                font-size: 14px;
                font-family: PingFangSC-regular;
            }
        }
    }
</style>